import { useLazyQuery, useMutation } from "@apollo/client";
import FontPicker from "font-picker-react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { NotificationManager } from "react-notifications";
import { useHistory } from "react-router-dom";
import EditorConvertToMarkdown from "../../components/EditorConvertToMarkdown";
import ModalLoader from "../../components/ModalLoader/ModalLoader";
import OpenTextBox from "../../components/OpenTextBlock";
import { UPDATE_FORM_QUESTION } from "../../GraphQL/Mutations";
import { GET_FORM_QUESTIONS } from "../../GraphQL/Queries";
import { ContextQuestions } from "../../Store/StoreQuestions";
import DropdownSingleSelectContainer from "../DropdownSingleSelectContainer";
import ImageRatingContainer from "../ImageRatingContainer";
import MultipleChoiceMultiSelectContainer from "../MultipleChoiceMultiSelectContainer";
import MultipleChoiceSingleSelectContainer from "../MultipleChoiceSingleSelectContainer";
import QuestionYesNoContainer from "../QuestionYesNoContainer";
import { ReactComponent as ImgPreviewEmpty } from "../../assets/svg/additional-data-preview-empty.svg";
import { theme as themeConfig } from "../../themes/themes";
import {
  BlockWrapper,
  ButtonSubmit,
  GeneralStyle,
  HeaderDependency,
  PreviewElements,
  StyledButton,
  SurveyQuestionConfigurationContainer,
  TitlePreview,
  RightContent,
  customStyles,
  FileUpload,
  TitleAdditionalData,
  ContentPreviewEmpty,
} from "./FormPreviewPanel.styled";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import { clientPolicyIngsight } from "../../App";
import AttachFileQuestionBlock from "../../components/AttachFileQuestionBlock";
import HighAlertQuestionBlock from "../../components/HighAlertQuestionBlock";
import { Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { IconButton } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PropTypes from "prop-types";

const FormPreviewPanel = ({
  idForm,
  formName,
  handleSaveFormConfigurations,
  formConfig,
  additionalDataPreview,
  selectedMenu,
}) => {
  const history = useHistory();
  const [showLoader, setshowLoader] = useState(false);
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);
  const [title, setTitle] = useState("");
  const [textButton, setTextButton] = useState("Send");
  const [colorPickerPreview] = useState("#ffffff");
  const [backgroundPreview] = useState("");
  const [surveyStateId] = useState(null);
  const [activeSubmittApproval] = useState(false);
  const rUploadFile = useRef();
  const [updateFormQuestion] = useMutation(UPDATE_FORM_QUESTION, {
    client: clientPolicyIngsight,
  });

  const timeOptions = [
    {
      value: "Seconds",
      label: "Seconds",
    },
    {
      value: "Minutes",
      label: "Minutes",
    },
    {
      value: "Hours",
      label: "Hours",
    },
    {
      value: "Days",
      label: "Days",
    },
  ];

  const [runQueryFormQuestions] = useLazyQuery(GET_FORM_QUESTIONS, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-and-network",
    client: clientPolicyIngsight,
    onCompleted: (data) => {
      if (data?.formQuestionsByIdForm) {
        let questions = [...data.formQuestionsByIdForm];
        questions.sort((a, b) => a.questionOrder - b.questionOrder);
        questions.forEach((item, index) => {
          let config = {};
          if (item.jsonConfiguration)
            config = JSON.parse(item.jsonConfiguration);
          dispatch({
            type: "ADD_QUESTIONS",
            payload: {
              Gtype: item.questionType,
              GindexQuestion: index,
              Gactive: true,
              GidSurvey: idForm,
              GidQuestion: item.idQuestionForm,
              GidCategoryQuestion: "",
              GnameQuestion: item.questionTitle,
              GvalidationText: config?.validationText,
              GidQuestionSurvey: item.idQuestionForm,
              GisMandatory: item.isMandatory,
              GjsonConfiguration: item.jsonConfiguration,
              Gorder: item.questionOrder,
              GisEdit: false,
              GisDependent: item?.isDependent,
              GidParentQuestion: item.isDependent ? item.idParentQuestion : 0,
              GdependentAnswer: item.isDependent ? item.dependentAnswer : "",
            },
          });
        });

        setshowLoader(false);
      }
    },
  });

  useEffect(() => {
    if (idForm) {
      runQueryFormQuestions({
        variables: {
          idForm,
        },
      });
      setshowLoader(true);
    }

    return () => dispatch({ type: "CLEAN_QUESTIONS" });
  }, [idForm]);

  useEffect(() => {
    if (formConfig) {
      let textButtonSave = formConfig?.TextButtonSave?.jsonConfiguration;
      let titleText = formConfig?.Title?.jsonConfiguration;
      if (textButtonSave) {
        setTextButton(JSON.parse(textButtonSave)?.text);
      }
      if (titleText) {
        setTitle(JSON.parse(titleText)?.text);
      }
    }
  }, [formConfig]);

  const handleSave = () => {
    if (title && title.trim() !== "") {
      if (stateQuestionsReducer?.questions?.length > 0) {
        let config = {};
        config["TextButtonSave"] = {
          jsonConfiguration: JSON.stringify({
            text: textButton,
          }),
        };
        config["Title"] = {
          jsonConfiguration: JSON.stringify({
            text: title,
          }),
        };
        handleSaveFormConfigurations(JSON.stringify(config));
      } else {
        NotificationManager.warning("Please add atleast one question in form ");
      }
    } else {
      NotificationManager.warning("Please enter the form title");
    }
  };

  const OrderQuestions = (questionIndexChanged) => {
    let questionOrderChanged =
      stateQuestionsReducer.questions[questionIndexChanged];
    updateFormQuestion({
      variables: {
        idQuestionForm: questionOrderChanged.GidQuestion,
        questionOrder: questionIndexChanged + 1,
      },
    })
      .then((res) => {
        if (res?.data?.updateFormQuestion?.idQuestionForm) {
          let copy = JSON.parse(JSON.stringify(stateQuestionsReducer));
          dispatch({ type: "CLEAN_QUESTIONS" });
          dispatch({ type: "DELETE_QUESTIONS", payload: copy });
        } else {
          NotificationManager.error("Error updating questions", "", 5000);
        }
        setshowLoader(false);
      })
      .catch((error) => {
        const errorMessage = error.message.split("\n")[0];
        NotificationManager.error(errorMessage, "", 5000);

        setshowLoader(false);
      });
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;
    if (stateQuestionsReducer.questions[result.source.index].GisDependent) {
      NotificationManager.warning(
        "You can not move it, this question is dependent on another",
        "",
        5000
      );
      return;
    }
    if (stateQuestionsReducer.questions.filter((f) => f.GisEdit).length) {
      NotificationManager.warning(
        "You have pending questions to save",
        "",
        5000
      );
      return;
    }
    if (
      (result.destination.index > result.source.index &&
        stateQuestionsReducer.questions[result.destination.index + 1] !==
        undefined &&
        stateQuestionsReducer.questions[result.destination.index + 1]
          .GisDependent) ||
      (result.destination.index < result.source.index &&
        stateQuestionsReducer.questions[result.destination.index].GisDependent)
    ) {
      NotificationManager.warning(
        "You can not move the question inside the dependent questions",
        "",
        5000
      );
      return;
    }
    setshowLoader(true);
    const [reorderedItem] = stateQuestionsReducer.questions.splice(
      result.source.index,
      1
    );
    stateQuestionsReducer.questions.splice(
      result.destination.index,
      0,
      reorderedItem
    );
    stateQuestionsReducer.questions
      .filter((f) => f.GidParentQuestion === reorderedItem.GidQuestionSurvey)
      .forEach((m) => {
        const [reorderedItem] = stateQuestionsReducer.questions.splice(
          stateQuestionsReducer.questions.findIndex(
            (i) => i.GidQuestionSurvey === m.GidQuestionSurvey
          ),
          1
        );
        stateQuestionsReducer.questions.splice(
          result.destination.index < result.source.index
            ? result.destination.index + 1
            : result.destination.index,
          0,
          reorderedItem
        );
      });

    OrderQuestions(result.destination.index);
  };

  const renderQuestions = (q, index, array) => {
    switch (q.Gtype) {
      case "OpenText":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <OpenTextBox
                disableButton={surveyStateId === 6}
                identity={"form"}
                key={q.GidQuestion}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "ImageRating":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <ImageRatingContainer
                identity="form"
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "MultipleChoiceMultiSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <MultipleChoiceMultiSelectContainer
                identity="form"
                disableButton={surveyStateId === 6}
                key={q.GidQuestion}
                {...q}
              />
            </BlockWrapper>
          </>
        );
      case "MultipleChoiceSingleSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <MultipleChoiceSingleSelectContainer
                identity="form"
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
              />
            </BlockWrapper>
          </>
        );
      case "QuestionYesNo":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <QuestionYesNoContainer
                identity="form"
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
              />
            </BlockWrapper>
          </>
        );
      case "DropdownSingleSelect":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <DropdownSingleSelectContainer
                identity="form"
                disableButton={surveyStateId === 6}
                {...q}
                key={q.GidQuestion}
              />
            </BlockWrapper>
          </>
        );
      case "File":
        return (
          <>
            {q.GisDependent &&
              q.GdependentAnswer !==
              array[index === 0 ? index : index - 1].GdependentAnswer && (
                <HeaderDependency>
                  <span>{q.GdependentAnswer}</span>
                </HeaderDependency>
              )}
            <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
              <AttachFileQuestionBlock {...q} key={q.GidQuestion} />
            </BlockWrapper>
          </>
        );
      default:
        break;
    }
  };

  const renderAdditionalDataQuestions = (q, index, array) => {
    if (q.Gtype === "FreeText") {
      return (
        <>
          {q.GisDependent &&
            q.GdependentAnswer !==
            array[index === 0 ? index : index - 1].GdependentAnswer && (
              <HeaderDependency>
                <span>{q.GdependentAnswer}</span>
              </HeaderDependency>
            )}
          <BlockWrapper isDependent={q.GisDependent} key={q.GidQuestion}>
            <OpenTextBox
              disableButton={false}
              identity={selectedMenu}
              key={q.GidQuestion}
              {...q}
            />
          </BlockWrapper>
        </>
      );
    }
  };

  let renderAdditionalDataPreview = (
    item,
    mandatory,
    questionType,
    data,
    index
  ) => {
    switch (questionType) {
      case "File":
        return (
          <>
            <Col md={8} className="mt-2">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                <>
                  Attach additional files{" "}
                  {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
                </>
              </Form.Label>
            </Col>
            <Col md={4}>
              <IconButton>
                <AddCircleOutlineIcon />
                <FileUpload
                  ref={rUploadFile}
                  type="file"
                  accept=".jpg,.png,.jpeg,application/pdf"
                />
              </IconButton>
            </Col>
          </>
        );
      case "FreeText":
        return (
          <>
            <BlockWrapper key={data.idFormAdditionalDataQuestion}>
              <OpenTextBox
                disableButton={false}
                identity={selectedMenu}
                key={index}
                GidSurvey={idForm}
                GidQuestionSurvey={data.idFormAdditionalDataQuestion}
                GnameQuestion={data.title}
                GisMandatory={data.isMandatory}
                GjsonConfiguration={""}
              />
            </BlockWrapper>
          </>
        );
      case "List":
        return renderAddionalData(item, mandatory);

      default:
        break;
    }
  };

  const renderAddionalData = (item, mandatory) => {
    switch (item) {
      case "Primary Benefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                Primary Benefit{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );
      case "Secondary Benefit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                Secondary Benefit{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Form.Control
                type="number"
                style={{ fontSize: "14px" }}
                placeholder="Numerical"
                required={mandatory}
              />
            </Col>
          </>
        );

      case "Impacted Policies":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                impacted policy/policies{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of policies applicable for the maket..."
                options={[
                  { value: 1, label: "Policy One" },
                  { value: 2, label: "Policy Two" },
                ]}
                isMandatory={mandatory}
                isMulti
              />
            </Col>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                Sub Policies{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="Sub Policies"
                options={[
                  { value: 1, label: "Sub Policy One" },
                  { value: 2, label: "Sub Policy Two" },
                ]}
                isMandatory={mandatory}
                isMulti
              />
            </Col>
          </>
        );

      case "Impacted Queues":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                impacted queue/queues{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of queues applicable for the maket..."
                options={[
                  { value: 1, label: "Queue One" },
                  { value: 2, label: "Queue Two" },
                ]}
                isMandatory={mandatory ? true : false}
                isMulti
              />
            </Col>
          </>
        );
      case "Applicable Market":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                Applicable market(s){" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="List of markets in the site"
                options={[]}
                isMandatory={mandatory}
                isMulti
              />
            </Col>
          </>
        );

      case "Time Unit":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                Time Unit{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="Select"
                options={timeOptions}
                defaultValue={{ value: "Seconds", label: "Seconds" }}
                isMandatory={mandatory}
              />
            </Col>
          </>
        );

      case "Insights POC":
        return (
          <>
            <Col md="12">
              <Form.Label style={{ color: themeConfig.neutral.gray[2600], fontSize: "13px" }}>
                Add insights POC{" "}
                {mandatory && <span style={{ color: themeConfig.status.error }}>*</span>}
              </Form.Label>
            </Col>
            <Col md="12" className="mb-1">
              <Select
                styles={customStyles}
                placeholder="Select"
                options={[
                  { value: 1, label: "POC One" },
                  { value: 2, label: "POC Two" },
                ]}
                isMandatory={mandatory}
              />
            </Col>
          </>
        );

      default:
        break;
    }
  };

  return (
    <>
      <GeneralStyle
        colorPickerPreview={colorPickerPreview}
        backgroundPreview={backgroundPreview}
      >
        <SurveyQuestionConfigurationContainer
          surveyStateId={surveyStateId}
          activeSubmittApproval={activeSubmittApproval}
          idSurvey={idForm}
        >
          <TitlePreview>
            <span>{formName}</span>
          </TitlePreview>
          <RightContent>
            <ButtonSubmit onClick={() => handleSave()}>Save</ButtonSubmit>
            <CloseIcon
              onClick={() => {
                history.push("/PolicyFormsManagement");
              }}
            />
          </RightContent>
        </SurveyQuestionConfigurationContainer>

        <Row
          style={{ margin: "0px 8vw" }}
          hidden={selectedMenu !== "additional-data" ? true : false}
        >
          <TitleAdditionalData className="my-3">
            Additional Data Preview
          </TitleAdditionalData>
          <hr />
          {additionalDataPreview.length >= 1 ? (
            additionalDataPreview?.map((element, index) => (
              <Row className="my-3" key={index}>
                {renderAdditionalDataPreview(
                  element.title,
                  element.isMandatory,
                  element.questionType,
                  element,
                  index
                )}
              </Row>
            ))
          ) : (
            <ContentPreviewEmpty className="my-3">
              <ImgPreviewEmpty />
            </ContentPreviewEmpty>
          )}
          {stateQuestionsReducer.additionalQuestions.map((q, index, array) => (
            <div key={q.GidQuestion}>
              {renderAdditionalDataQuestions(q, index, array)}
            </div>
          ))}
        </Row>

        <div
          className="title-field"
          hidden={selectedMenu !== "additional-data" ? false : true}
        >
          <EditorConvertToMarkdown
            editor={title}
            setEditor={setTitle}
            style={{ width: "80%", maxWidth: "684px" }}
            placeHolder="Add form title here"
          />
        </div>
        <PreviewElements
          hidden={selectedMenu !== "additional-data" ? false : true}
        >
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="droppable-1">
              {(provided) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {stateQuestionsReducer.questions.map((q, index, array) => (
                    <Draggable
                      key={q.GidQuestion}
                      draggableId={`draggable-${index}`}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          {renderQuestions(q, index, array)}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <BlockWrapper>
            <HighAlertQuestionBlock />
          </BlockWrapper>
          {textButton && textButton.trim() !== "" ? (
            <StyledButton>{textButton}</StyledButton>
          ) : null}
        </PreviewElements>

        {/*BEGIN THIS IS FOR GETTING FONTS IN THE PREVIEW PANEL  */}
        <div style={{ display: "none" }}>
          <FontPicker
            pickerId={"prueba"}
            apiKey={process.env.GOOGLE_API_KEY}
            activeFontFamily={"Open Sans"}
            limit={100}
            onChange={(event) => { }}
          />
        </div>
        {/*END THIS IS FOR GETTING FONTS IN THE PREVIEW PANEL  */}
      </GeneralStyle>
      {showLoader && <ModalLoader></ModalLoader>}
    </>
  );
};

export default FormPreviewPanel;

FormPreviewPanel.propTypes = {
  idForm: PropTypes.number,
  formName: PropTypes.any,
  handleSaveFormConfigurations: PropTypes.func,
  formConfig: PropTypes.any,
  additionalDataPreview: PropTypes.any,
  selectedMenu: PropTypes.any,
};
